export const CONFIG_REQUEST = "CONFIG_REQUEST";